import { FC } from "react";
import Box from "../ui/Box";
import Button from "../ui/Button";
import NotfoundTable from "../ui/NotfoundTable";
import SpinnerLoader from "../ui/SpinnerLoader";

type Props = {
  loading: boolean;
  failed: boolean;
  empty: boolean;
  emptyText: string;
  phone: boolean;
  onRetry: () => void;
};

// What a polled list shows when it has no rows to show: still loading, failed to load, or genuinely empty.
const ListState: FC<Props> = ({ loading, failed, empty, emptyText, phone, onRetry }) => {
  if (failed) {
    return (
      <Box className="flex flex-col items-center gap-3 text-center">
        <p className="text-sm text-red">Lista nuk u ngarkua dot.</p>
        <Button className="h-11" onClick={onRetry}>
          Provo përsëri
        </Button>
      </Box>
    );
  }
  if (loading) return <SpinnerLoader className="py-10" />;
  if (!empty) return null;
  if (!phone) return <NotfoundTable header={emptyText} />;
  return <Box className="text-center text-sm text-neutral">{emptyText}</Box>;
};

export default ListState;
